import { render, staticRenderFns } from "./newFeedback.vue?vue&type=template&id=33994b03"
import script from "./newFeedback.vue?vue&type=script&lang=js"
export * from "./newFeedback.vue?vue&type=script&lang=js"
import style0 from "./newFeedback.vue?vue&type=style&index=0&id=33994b03&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports